var React = require('react');

function LinktrIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 1.25H38C42.8335 1.25 46.75 5.16819 46.75 10V38C46.75 42.8318 42.8335 46.75 38 46.75H10C5.16836 46.75 1.25 42.8316 1.25 38V10C1.25 5.16836 5.16836 1.25 10 1.25Z","stroke":"white","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 9H21.252V13.2519C28.3621 13.2519 34.126 19.0158 34.126 26.126C34.126 33.2361 28.3621 39 21.252 39V39H17V34.7481H21.252V30.2599H17V17.504H21.252V13.252H17V9ZM21.252 34.748C25.9921 34.748 29.8347 30.8877 29.8347 26.1259C29.8347 21.3641 25.9921 17.5039 21.252 17.5039V34.748Z","fill":"white","key":1})]);
}

LinktrIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = LinktrIcon;

LinktrIcon.default = LinktrIcon;
